export default __webpack_public_path__ + "static/media/mana0.fb4ab397.svg";